import { i18n } from "services/i18nService";
import {
  roundAndPadMoneyValue,
  decimalMaximumFractionDigits,
} from "services/utility/formatting";

import globalState from "globalState/globalState";

export function formatLinkedTransaction(value, metadata) {
  const transactionType = metadata?.transactionType || "";
  if (!value) {
    return { transactionType, refNumber: "", lineNumber: "" };
  } else {
    return {
      ...value,
      lineNumber: value.lineNumber === 0 ? "" : value.lineNumber,
    };
  }
}

export function formatLineDecimal(value, metadata) {
  const { currencyMinimumFractionDigits } =
    globalState.getState().userCompanySettings.localization;
  if (metadata.currency) {
    return roundAndPadMoneyValue(
      value,
      currencyMinimumFractionDigits,
      metadata.placesRight,
      false
    );
  } else {
    return decimalMaximumFractionDigits(value, metadata.placesRight, false);
  }
}

export function isElementAddedToOldArray(oldArray, newArray) {
  return newArray.reduce(
    (seed, element) => seed || !oldArray.includes(element),
    false
  );
}

export function getListHeaderText(objectType, totalRecords, retrievalParams) {
  if (!retrievalParams || !totalRecords) {
    return "";
  }
  return totalRecords === 0
    ? `${i18n("global.No")} ${i18n(`objectType.${objectType}.LowerPlural`)}`
    : `${retrievalParams.startingRecord} - ${Math.min(
        retrievalParams.startingRecord + retrievalParams.maxResults - 1,
        totalRecords
      )} of ${totalRecords}`;
}
